<template>
    <input
        type="tel"
        ref="input"
        class="input"
        :value="value"
        @input="onInput"
        @focus="onFocus"
        @blur="onBlur"
    />
</template>

<script>
import Inputmask from 'inputmask';

export default {
    props: {
        value: {
            type: String,
        },
        type: {
            type: String,
            default: 'text',
            validator: (v) => ['text', 'tel', 'search'].includes(v),
        },
        maskOptions: {
            type: Object,
            default: () => ({}),
        },
    },
    methods: {
        onInput(event) {
            this.$emit('input', event);
        },
        onFocus(event) {
            this.$emit('focus', event);
        },
        onBlur(event) {
            this.$emit('blur', event);
        },
        oncomplete() {
            this.$emit('complete');
        },
        onincomplete() {
            this.$emit('incomplete');
        },
        onKeyDown() {
            const isValid = this.inputmask.isValid();

            if (!isValid) {
                this.onincomplete();
            }
        },
        init() {
            const { oncomplete, onincomplete, onKeyDown } = this;

            this.inputmask = Inputmask({
                ...this.maskOptions,
                oncomplete,
                onincomplete,
                onKeyDown,
            }).mask(this.$refs.input);
        },
        destroy() {
            Inputmask.remove(this.$refs.input);
        },
    },
    watch: {
        options(val) {
            this.destroy();
            this.init();
        },
    },
    mounted() {
        this.init();
    },
    beforeDestroy() {
        this.destroy();
    },
};
</script>
